import React from 'react';

export default function LikeIcon({ liked }: { liked: boolean }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      fill="none"
      viewBox="0 0 20 21"
    >
      <path
        stroke="#4D4D4D"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={liked ? 'red' : 'none'}
        strokeWidth="1.5"
        d="M17.367 3.912a4.584 4.584 0 00-6.484 0L10 4.795l-.883-.883a4.584 4.584 0 10-6.484 6.483l.884.883L10 17.762l6.483-6.484.884-.883a4.585 4.585 0 000-6.483z"
      ></path>
    </svg>
  );
}
